import { render, staticRenderFns } from "./fwsx.vue?vue&type=template&id=469ed500&scoped=true&"
import script from "./fwsx.vue?vue&type=script&lang=js&"
export * from "./fwsx.vue?vue&type=script&lang=js&"
import style0 from "./fwsx.vue?vue&type=style&index=0&id=469ed500&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469ed500",
  null
  
)

export default component.exports